import { APIActions } from "../actions";
import {
  addExpense,
  updateExpense,
  updateScanningReceipt,
} from "../../store/features/expensesSlice";
import { store } from "../../store/store";

// Moeda forte da conta ainda não bateu com o valor exibido: o WS trouxe a
// despesa sem a conversão aplicada (ex.: leitor de notinhas)
const hasMissingConversion = (expense = {}, accountCurrency) => {
  const originalCurrency = expense?.originalAmount?.currency;
  if (!originalCurrency || !accountCurrency) return false;
  if (originalCurrency === accountCurrency) return false;
  return (
    !expense?.conversionAmount ||
    expense?.displayAmount?.currency !== accountCurrency
  );
};

const fixExpenseConversion = (expenseId) => {
  APIActions.expenses
    .detail({ expenseId, role: "personal" })
    .then((expense) => {
      if (!expense) return;
      store.dispatch(
        updateExpense({
          role: "personal",
          id: expenseId,
          changes: expense,
        })
      );
    })
    .catch((error) => {
      console.log("SCAN RECEIPT :: fix conversion error :: ", expenseId, error);
    });
};

export default (expensePayload = "") => {
  const payload = JSON.parse(expensePayload);
  const state = store.getState();
  const receipt = state.expenses.scanningReceipts[payload?.tempId];
  if (payload) {
    store.dispatch(
      addExpense({
        role: "personal",
        data: payload,
      })
    );

    if (
      payload?._id &&
      hasMissingConversion(payload, state.account?.baseInfo?.currency)
    ) {
      fixExpenseConversion(payload._id);
    }
  }
  if (receipt && payload?.tempId) {
    store.dispatch(
      updateScanningReceipt({
        id: payload?.tempId,
        changes: {
          status: "completed",
        },
      })
    );
  }
};
